module.exports = __webpack_public_path__ + "static/media/temusados.ab936bfb.png";